import React from "react";
import DonutChart from "../../components/donut-chart/index";

export const MedicinesDonutChart = () => {
  const donutOptions = {
    chart: {
      backgroundColor: "#F2F5F9",
    },
    credits: {
      text: "<span> Source: Nielsen - OTC Medicines - Total Impulse - Value Sales - MAT: 07.10.2023 <br> Nielsen - Nicotine Replacement Therapy - Total Impulse - Value Sales - MAT: 30.09.2023 <br> Nielsen - Pregnancy & Ovulation - Total Impulse - Value Sales - MAT: 11.11.2023 </span>",
      position: {
        y: -100,
        align: "center",
      },
      style: {
        fontSize: "10px",
        color: "#092f50",
      },
    },
    title: {
      text: "",
      align: "left",
      x: 0,
      y: 10,
    },
    tooltip: {
      useHTML: true,
      style: {
        fontSize: "14px",
      },
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 860,
          },

          chartOptions: {
            plotOptions: {
              pie: {
                center: ["50%", "60%"],
              },
            },
            tooltip: {
              fontSize: "12px",
            },
            series: {
              size: "55%",
            },
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              itemMarginTop: 5,
              itemMarginBottom: 0,
              padding: 0,
              x: 0,
              y: -60,
              floating: false,
              itemStyle: {
                fontSize: "12px",
              },
            },
            credits: {
              position: {
                y: -50,
              },
              style: {
                fontSize: "7px",
              },
            },
          },
        },
        {
          condition: {
            maxWidth: 480,
          },
          chartOptions: {
            credits: {
              style: {
                width: "300px",
              },
            },
          },
        },
      ],
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "top",
      x: -50,
      y: 30,
      floating: true,
      itemStyle: {
        color: "#092f50",
        fontWeight: 500,
        fontSize: "14px",
      },
      itemMarginTop: 5,
      itemMarginBottom: 0,
      padding: 5,
      useHTML: true,
      labelFormatter: function () {
        var legendItem = document.createElement("div"),
          symbol = document.createElement("span"),
          label = document.createElement("span");
        symbol.innerText = this.y + "%";
        symbol.style.borderColor = this.color;
        symbol.classList.add("xLegendSymbol");
        label.innerText = this.test;
        legendItem.appendChild(symbol);
        legendItem.appendChild(label);
        return legendItem.outerHTML;
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
        },
        shadow: false,
        center: ["50%", "50%"],
        borderWidth: 0,
      },
    },
    series: [
      {
        type: "pie",
        size: "60%",
        innerSize: "70%",
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
        data: [
          {
            test: "Adult Pain",
            y: 35,
            value: "£44.4m",
            color: "rgba(35, 172, 202, 1)",
          },
          {
            test: "Cold & Flu",
            y: 11,
            value: "£14.0m",
            color: "rgba(35, 172, 202, .9)",
          },
          {
            test: `Children's Medicines`,
            y: 11,
            value: "£13.3m",
            color: "rgba(35, 172, 202, .85)",
          },
          {
            test: "Heartburn & Indigestion",
            y: 10,
            value: "£12.1m",
            color: "rgba(35, 172, 202, .75)",
          },
          {
            test: "Cough Remedies",
            y: 6,
            value: "£6.8m",
            color: "rgba(35, 172, 202, .65)",
          },
          {
            test: "Decongestants",
            y: 6,
            value: "£6.8m",
            color: "rgba(35, 172, 202, .55)",
          },
          {
            test: "Sexual Wellbeing",
            y: 5,
            value: "£6.2m",
            color: "rgba(35, 172, 202, .60)",
          },
          {
            test: "Sore Throat",
            y: 5,
            value: "£5.7m",
            color: "rgba(35, 172, 202, .50)",
          },
          {
            test: "Digestive Health",
            y: 4,
            value: "£4.6m",
            color: "rgba(35, 172, 202, .30)",
          },
          {
            test: "Allergy",
            y: 4,
            value: "£4.5m",
            color: "rgba(35, 172, 202, .40)",
          },
          {
            test: "First Aid",
            y: 2,
            value: "£3.0m",
            color: "rgba(35, 172, 202, .20)",
          },
          {
            test: "Body Health",
            y: 1,
            value: "£764k",
            color: "rgba(35, 172, 202, .10)",
          },
        ],
        tooltip: {
          headerFormat: "",
          pointFormatter() {
            const output = `
                   <strong>${this.y}%</strong> <br />
                    ${this.test}
                    `;
            return output;
          },
        },
      },
    ],
  };

  return (
    <div className='page-wrapper'>
      <div className='donut-card'>
        <div>
          <p className='heading'>Healthcare & Medicines</p>
        </div>
        <div>
          <p className='independents'>Independents £122.7m</p>
          <p className='percent'>(+9.4% YoY)</p>
        </div>
      </div>
      <DonutChart options={donutOptions} />
    </div>
  );
};
